exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".QPOqdnK3YcwPvVWrT1JAx:active{opacity:.9}.QPOqdnK3YcwPvVWrT1JAx svg{display:block;height:20px;width:auto}._3UOMCEIXcXsKkhSikKpTpj{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;position:absolute;top:0;left:0;-webkit-transition:-webkit-transform .3s ease-out;transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out;transition:transform .3s ease-out,-webkit-transform .3s ease-out;padding:12px 15px;-webkit-transform:translate3d(0,-60px,0);transform:translate3d(0,-60px,0);-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;width:calc(100% - 90px)}", ""]);

// exports
exports.locals = {
	"logo": "QPOqdnK3YcwPvVWrT1JAx",
	"header": "_3UOMCEIXcXsKkhSikKpTpj"
};